import { AuditOutlined, CloudDownloadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useStyles } from "../styles";
import { SignInfo } from "./SignInfo";
import { getFile } from "../utils/getFile";
import { getShortFileName } from "../utils/getShortFileName";
import { formatFileSize } from "../utils/formatFileSize";
import { BASE_URL } from "@services/api";

const API_URL_PREFIX = `${BASE_URL}/front-agent`;
// const API_EXTERNAL_TASK_PREFIX = "api/ext-task";

export const FileItem = ({ file, canRemoveFile, onRemove, toggleSignInfo, isSignInfoOpen }) => {
  const classes = useStyles();
  // const { isExternalTask, token } = useExternalTask();

  const { fileName, fileId, signInfo } = file || {};

  const url = `${BASE_URL}/front-agent/document/file/${fileId}`;
  // const externalTaskUrl = `/${API_EXTERNAL_TASK_PREFIX}/public/file/${fileId}`;
  // const externalTaskUrlToken = `${externalTaskUrl}?token=${token}`;

  const signedUrl = `${url}/sign`;
  const originalUrl = `${url}/original`;
  const stampedUrl = `${url}/stamped`;

  const downloadFile = (href: string, name?: string) => async (e) => {
    e?.preventDefault();
    await getFile(href, name);
  };

  const originalFileName = fileName?.split(".sig")?.join("");
  const isFileSigned = fileName?.toLowerCase()?.endsWith(".sig");
  const signIconClasses =
    typeof file.signInfo === "undefined" || !file.signInfo
      ? classes.link
      : signInfo?.isValid
        ? classes.isFileSignedStyle
        : classes.isFileNotSignedStyle;

  return (
    <>
      <div className={classes.file}>
        {isFileSigned ? (
          <>
            <Tooltip title="Скачать оригинал" arrowPointAtCenter>
              <span className={classes.link} onClick={downloadFile(originalUrl, originalFileName)}>
                <span>
                  {getShortFileName(originalFileName)}
                  <span className={classes.fileSize}>{formatFileSize(file.size)}</span>
                </span>
              </span>
            </Tooltip>
            <Tooltip title="Скачать подписанный файл" arrowPointAtCenter>
              <span className={classes.link} onClick={downloadFile(signedUrl)}>
                <CloudDownloadOutlined />
              </span>
            </Tooltip>
            {signInfo?.isValid && (
              <Tooltip title="Скачать pdf-образ со штампом" arrowPointAtCenter>
                <span className={classes.link} onClick={downloadFile(stampedUrl)}>
                  <AuditOutlined />
                </span>
              </Tooltip>
            )}
            <Tooltip title="Информация о подписи" arrowPointAtCenter>
              <span className={signIconClasses} onClick={toggleSignInfo(fileId)}>
                <InfoCircleOutlined />
              </span>
            </Tooltip>
          </>
        ) : (
          <span
            className={classes.link}
            title={url}
            onClick={downloadFile(url, fileName)}
          >
            <span>
              {getShortFileName(fileName)}
              <span className={classes.fileSize}>{formatFileSize(file.size)}</span>
            </span>
          </span>
        )}
        {canRemoveFile && (
          <a onClick={onRemove(fileId)} title={`Удалить ${fileName}`}>
            ❌
          </a>
        )}
      </div>
      {isSignInfoOpen[fileId] && <SignInfo signInfo={signInfo} />}
    </>
  );
};
